import * as types from '../actions/actionTypes';

const initialState = {
  roles: [],
  selectedRole: null,
  loading: false,
  error: null,
  meta: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Roles
    case types.FETCH_ROLES_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: action.payload.data,
        meta: action.payload.meta,
        error: null,
      };
    case types.FETCH_ROLES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch Single Role
    case types.FETCH_ROLE_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedRole: action.payload,
        error: null,
      };
    case types.FETCH_ROLE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Create Role
    case types.CREATE_ROLE_REQUEST:
      return { ...state, loading: true, error: null };
    case types.CREATE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: [action.payload, ...state.roles],
        error: null,
      };
    case types.CREATE_ROLE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Update Role
    case types.UPDATE_ROLE_REQUEST:
      return { ...state, loading: true, error: null };
    case types.UPDATE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: state.roles.map((role) =>
          role.id === action.payload.id ? action.payload : role
        ),
        selectedRole: action.payload,
        error: null,
      };
    case types.UPDATE_ROLE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Delete Role
    case types.DELETE_ROLE_REQUEST:
      return { ...state, loading: true, error: null };
    case types.DELETE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: state.roles.filter((role) => role.id !== action.payload),
        error: null,
      };
    case types.DELETE_ROLE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Assign Permissions
    case types.ASSIGN_PERMISSIONS_TO_ROLE_REQUEST:
      return { ...state, loading: true, error: null };
    case types.ASSIGN_PERMISSIONS_TO_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedRole: action.payload,
        error: null,
      };
    case types.ASSIGN_PERMISSIONS_TO_ROLE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default roleReducer;